import styled from "styled-components";

import Chip from "@material-ui/core/Chip";

export const StyledChip = styled(Chip)`
    margin: 2px;
`;
